import { MenuContentCmp as MenuContent } from '../../components/MenuCmp';
import UIControls from '../../components/UIControlsCmp';
import Urls from '../../constants/urls';
import firstFloorPlan from "./imgs/1st_Floor_Plan.jpg";
import secondFloorPlan from "./imgs/2nd_Floor_Plan.jpg";
import { ImageMap } from '@qiuz/react-image-map';
import { useHistory, useLocation } from "react-router-dom";
import spot from "../../icons/spot.png"
import Button from 'react-bootstrap/Button';
import './ISMenu.css'

const ISMenu = () => {
    const history = useHistory()
    const location = useLocation();
    let roomName = "entrance";
    let isFirstFloor = true;
    if (location.pathname.split('/').length >= 3) {
        roomName = location.pathname.split('/')[2];
        isFirstFloor = !roomName.includes('upstairs');
    }
    
    const firstFloorMapArea = [
        {
            url: Urls.ivyShop.entrance.path,
            width: '5%',
            height: '5%',
            left: '49%',
            top: '77%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.entranceDisplay.path,
            width: '5%',
            height: '5%',
            left: '68%',
            top: '65%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.exitDisplay.path,
            width: '5%',
            height: '5%',
            left: '68%',
            top: '30%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.center.path,
            width: '5%',
            height: '5%',
            left: '49%',
            top: '50%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.hayBales.path,
            width: '5%',
            height: '5%',
            left: '40%',
            top: '58%',
            render: () => (
              <span className='overview-map-button mobile-hidden' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.exit.path,
            width: '5%',
            height: '5%',
            left: '47%',
            top: '10%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.corner.path,
            width: '5%',
            height: '5%',
            left: '10%',
            top: '17%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
    ];

    const secondFloorMapArea = [
        {
            url: Urls.ivyShop.upstairsCenter.path,
            width: '5%',
            height: '5%',
            left: '50%',
            top: '85%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.upstairsDisplay.path,
            width: '5%',
            height: '5%',
            left: '70%',
            top: '68%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.upstairsEntrance.path,
            width: '5%',
            height: '5%',
            left: '30%',
            top: '68%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.corner.path,
            width: '5%',
            height: '5%',
            left: '15%',
            top: '15%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.exit.path,
            width: '5%',
            height: '5%',
            left: '47%',
            top: '10%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
        {
            url: Urls.ivyShop.exit.path,
            width: '5%',
            height: '5%',
            left: '47%',
            top: '10%',
            render: () => (
              <span className='overview-map-button' >
                <img src={spot} />
              </span>
            ),
        },
    ]

    const onMapClick = (area) => {
        console.log(area);
        history.push(area.url)
    }

    const changeFloor = () => {
        if (isFirstFloor) {
            history.push(Urls.ivyShop.upstairsEntrance.path) 
        } else {
            history.push(Urls.ivyShop.entrance.path)
        }
    }

    return (
        <>
            <MenuContent>
                <div id="floor-selector">
                    <h1>Where do you want to go?</h1>
                        <Button onClick={changeFloor} variant="dark">
                            {isFirstFloor ? <>Go upstairs</>: <>Go downstairs</>}
                        </Button>
                </div>
                { isFirstFloor ?  
                    <ImageMap
                        className="usage-map shrink"
                        id="ivyshop-map"
                        src={firstFloorPlan}
                        map={firstFloorMapArea}
                        onMapClick={onMapClick}
                    />:
                    <ImageMap
                        className="usage-map shrink"
                        id="ivyshop-map"
                        src={secondFloorPlan}
                        map={secondFloorMapArea}
                        onMapClick={onMapClick}
                    />
                }
            </MenuContent> 
            <UIControls
                cart
                homeUrl={Urls.ivyShop.outsideCenter.path}
            />
        </>
    );
}
    
export default ISMenu;